export default __webpack_public_path__ + "static/media/logo.fd676d43.svg";